export enum ImplementationTimelineLabels {
  overdue = 'Overdue',
  immediate = 'Immediate',
  twoWeeks = 'Two Weeks+',
  noRush = 'No Rush',
}

export enum ImplementationTimelineFieldNames {
  OVERDUE = 'overdue',
  IMMEDIATE = 'immediate',
  TWO_WEEKS = 'twoWeeks',
  NO_RUSH = 'noRush',
}

export enum SeverityLabels {
  critical = 'Critical',
  high = 'High',
  medium = 'Medium',
  low = 'Low',
}

export enum SeverityFieldNames {
  CRITICAL = 'critical',
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}

export enum OwnershipLabels {
  owner = 'Owner',
  accountables = 'Accountable',
  consulteds = 'Contributor',
  informeds = 'Informed',
}

export enum OwnershipFieldNames {
  OWNER = 'owner',
  ACCOUNTABLES = 'accountables',
  CONSULTEDS = 'consulteds',
  INFORMEDS = 'informeds',
}

export enum AssignedRolesEnum {
  MANAGEMENT,
  HR_TEMA,
  IT_TEAM,
  COO_OFFICE,
  SECURITY_DIVISION,
}

export const AssignedRolesColors = {
  [AssignedRolesEnum.MANAGEMENT]: '#2D62E8',
  [AssignedRolesEnum.HR_TEMA]: '#0AF2D6',
  [AssignedRolesEnum.IT_TEAM]: '#8542F3',
  [AssignedRolesEnum.COO_OFFICE]: '#0213A8',
  [AssignedRolesEnum.SECURITY_DIVISION]: '#1A7F9E',
};

export enum ImplementationTimelineEnum {
  noRush = 0,
  twoWeeks,
  immediate,
  overdue,
}

export enum SeverityEnum {
  low = 0,
  medium,
  high,
  critical,
}

export enum OwnershipEnum {
  owner = 0,
  accountable,
  contributer,
  informed,
}

export interface Domain {
  domainId: number;
  domainName: string;
}

export interface OwnerInfo {
  ownerID: string;
  stakeHolderName: string;
  ownerFullName: string;
}

export interface ActionBox {
  mode: 'Warning' | 'Error';
  messageId: string;
  eligibleActions: string[];
  visible: boolean;
  messageArgs: any;
}

export type Pagination<T, TItemsKey extends string = 'items'> = {
  [K in TItemsKey]: T[];
} & {
  totalCount: number;
  totalPages: number;
  pageNumber: number;
  pageSize: number;
  shownItemsFrom: number;
  shownItemsTo: number;
};
